interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <nav aria-label="分页" className="flex flex-wrap items-center justify-center gap-1.5">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        aria-label="上一页"
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-700 transition-colors duration-200 hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line text-lg" aria-hidden="true" />
      </button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          aria-current={p === page ? "page" : undefined}
          className={`h-9 min-w-9 rounded-md px-2 text-sm font-medium transition-colors duration-200 ${
            p === page
              ? "bg-primary-500 text-background-50"
              : "border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        aria-label="下一页"
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-700 transition-colors duration-200 hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-right-s-line text-lg" aria-hidden="true" />
      </button>
    </nav>
  );
}